import React from "react";

const PreviousIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="#F0F1FA" />
      <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#F0E4F8" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.3712 7.29289C19.7617 7.68342 19.7617 8.31658 19.3712 8.70711L12.0783 16L19.3712 23.2929C19.7617 23.6834 19.7617 24.3166 19.3712 24.7071C18.9806 25.0976 18.3475 25.0976 17.957 24.7071L9.95696 16.7071C9.56643 16.3166 9.56643 15.6834 9.95696 15.2929L17.957 7.29289C18.3475 6.90237 18.9806 6.90237 19.3712 7.29289Z"
        fill="#6E00BE"
      />
    </svg>
  );
};

export default PreviousIcon;
